// API-Client für FileMaker-Updates
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

// Logout API
export async function logoutApi(token) {
  return axios.post(`${API}/logout`, {}, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}


export async function updateCustomerInfo({ institution, adresszusatz, name, street, city, postal_code, email, recid, token }) {
  // Backend muss diesen Endpoint bereitstellen!
  return axios.post(`${API}/update-customer-info`, {
    institution,
    adresszusatz,
    name,
    street,
    city,
    postal_code,
    email,
    recid
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}

// Invoice address update API
export async function updateInvoiceAddressInfo({ institution, adresszusatz, name, street, city, postal_code, email, recid, token }) {
  // Backend muss diesen Endpoint bereitstellen!
  return axios.post(`${API}/update-invoice-address-info`, {
    institution,
    adresszusatz,
    name,
    street,
    city,
    postal_code,
    email,
    recid
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
}
